module.exports = __webpack_public_path__ + "static/media/Memb-I-00131_0017.f3205de4.jpg";